import { render } from "./MbImageDisp.vue?vue&type=template&id=735c403c"
import script from "./MbImageDisp.vue?vue&type=script&lang=js"
export * from "./MbImageDisp.vue?vue&type=script&lang=js"

import "./MbImageDisp.vue?vue&type=style&index=0&id=735c403c&lang=scss"
script.render = render

export default script